import { store } from '../store'

export function authHeader () {
  const { clubs } = store.state

  let user = JSON.parse(localStorage.getItem('user'))
  if (user && user.token) {
    return {
      'Authorization': '' + user.token,
      'Content-Type': 'application/json',
      'X-Chosen-Club-Index': clubs.chosenClubIndex
    }
  } else {
    return {}
  }
}

export function authHeaderMultipart () {
  let user = JSON.parse(localStorage.getItem('user'))
  if (user && user.token) {
    return {
      'Authorization': '' + user.token,
      'Content-Type': 'multipart/form-data'
    }
  } else {
    return {}
  }
}



// WEBPACK FOOTER //
// ./src/backend/authHeader.js